import EmblaCarousel from 'embla-carousel'

export default (function () {
    const carousels = document.querySelectorAll('[data-carousel]')
    carousels.forEach((carousel) => initCarousel(carousel))
})

const initCarousel = (carousel) => {
    const wrapper = carousel.querySelector('.wrapper')
    const slides = carousel.querySelectorAll('.slide-container > *')
    if (slides.length === 0) return

    const options = {
        align: 'start',
    }

    const carouselApi = EmblaCarousel(wrapper, options)

    carousel.querySelector('.slide-container').style.marginLeft = 'calc(var(--slide-spacing) * -1)'

    slides.forEach((slide, i) => {
        slide.classList.add(`pl-[var(--slide-spacing)]`)
        slide.classList.add(`flex-[0_0_var(--slide-size)]`)
        slide.classList.add(`lg:flex-[0_0_var(--slide-size-large)]`)
        slide.setAttribute('role', 'group')
        slide.setAttribute(
            'aria-label',
            `${carousel.getAttribute('data-label-slide')} ${i + 1} ${carousel.getAttribute('data-label-of')} ${slides.length}`
        )
    })

    const hasNavigation = carousel.querySelector('[data-carousel-previous-button]')
    if (hasNavigation) addButtonNavigation(carousel, carouselApi)

    const dotsContainer = carousel.querySelector('[data-carousel-dots-navigation]')

    if (dotsContainer) addDotNavigation(carouselApi, dotsContainer)

    const carouselId = carousel.getAttribute('data-carousel')
    if (carouselId !== '') addSplitLayout(carouselApi, carouselId)

    const thumbnails = carousel.querySelectorAll('[data-thumbnail-index]')
    if (thumbnails.length !== 0) addThumbnailNavigation(carouselApi, thumbnails)
}

const addButtonNavigation = (carousel, api) => {
    const prevButtons = carousel.querySelectorAll('[data-carousel-previous-button]')
    const nextButtons = carousel.querySelectorAll('[data-carousel-next-button]')

    if (!prevButtons.length || !nextButtons.length) return

    addTogglePrevNextButtonsActive(api, prevButtons, nextButtons)
    addPrevNextButtonsClickHandlers(api, prevButtons, nextButtons)
}

const addTogglePrevNextButtonsActive = (api, prevButtons, nextButtons) => {
    const togglePrevNextButtonsState = () => {
        if (api.canScrollPrev()) prevButtons.forEach(button => button.removeAttribute('disabled'))
        else prevButtons.forEach(button => button.setAttribute('disabled', 'disabled'))

        if (api.canScrollNext()) nextButtons.forEach(button => button.removeAttribute('disabled'))
        else nextButtons.forEach(button => button.setAttribute('disabled', 'disabled'))
    }

    api.on('select', togglePrevNextButtonsState).on('init', togglePrevNextButtonsState).on('reInit', togglePrevNextButtonsState)

    return () => {
        prevButtons.forEach(button => button.removeAttribute('disabled'))
        nextButtons.forEach(button => button.removeAttribute('disabled'))
    }
}

const addPrevNextButtonsClickHandlers = (api, prevButtons, nextButtons) => {
    const scrollPrev = () => {
        api.scrollPrev()
    }
    const scrollNext = () => {
        api.scrollNext()
    }
    prevButtons.forEach(button => button.addEventListener('click', scrollPrev, false))
    nextButtons.forEach(button => button.addEventListener('click', scrollNext, false))

    const removeTogglePrevNextButtonsActive = addTogglePrevNextButtonsActive(api, prevButtons, nextButtons)

    return () => {
        removeTogglePrevNextButtonsActive()
        prevButtons.forEach(button => button.removeEventListener('click', scrollPrev, false))
        nextButtons.forEach(button => button.removeEventListener('click', scrollNext, false))
    }
}

const addDotNavigation = (api, dotsContainer) => {
    let dotElements = []

    const addDotBtnsWithClickHandlers = () => {
        dotsContainer.innerHTML = api
        .scrollSnapList()
        .map(() => `<li data-dot class='group'><button class='button--carousel-dot' type='button'></button></li>`)
        .join('')

        const scrollTo = (index) => {
            api.scrollTo(index)
        }

        const labelsSlide = document.querySelector('[data-labels]')
        const labelSlide = labelsSlide.getAttribute('data-label-slide')
        const labelOf = labelsSlide.getAttribute('data-label-of')

        dotElements = Array.from(dotsContainer.querySelectorAll('[data-dot]'))
        dotElements.forEach((dot, index) => {
            const button = dot.querySelector('button')
            button.setAttribute('aria-label', `${labelSlide} ${index + 1} ${labelOf} ${dotElements.length}`)
            button.addEventListener('click', () => scrollTo(index), false)
        })
    }

    const toggleDotBtnsActive = () => {
        const previous = api.previousScrollSnap()
        const selected = api.selectedScrollSnap()
        dotElements[previous]?.classList.remove('active')
        dotElements[selected]?.classList.add('active')

        dotElements.forEach((dot) => {
            dot.querySelector('button')?.setAttribute('aria-current', 'false')
        })
        dotElements[selected].querySelector('button')?.setAttribute('aria-current', 'true')
    }

    api.on('init', addDotBtnsWithClickHandlers).on('reInit', addDotBtnsWithClickHandlers).on('init', toggleDotBtnsActive).on('reInit', toggleDotBtnsActive).on('select', toggleDotBtnsActive)

    return () => {
        dotsContainer.innerHTML = ''
    }
}

const addSplitLayout = (api, type) => {
    const contentToSplit = document.querySelectorAll(`[data-carousel-id='${type}']`)

    const toggleContentActive = () => {
        const activeIndex = api.selectedScrollSnap()

        contentToSplit.forEach((content) => {
            const slides = content.querySelectorAll(':scope > *')
            slides.forEach((slide) => slide.classList.add('opacity-0'))
            slides[activeIndex].classList.remove('opacity-0')
        })
    }

    api.on('select', toggleContentActive)
    api.on('init', toggleContentActive)
}

const addThumbnailNavigation = (api, thumbnails) => {
    const goToIndex = (index) => {
        api.scrollTo(Number(index))
    }

    thumbnails.forEach((thumbnail) => {
        const index = thumbnail.getAttribute('data-thumbnail-index')
        thumbnail.addEventListener('click', () => goToIndex(index), false)

        return () => {
            thumbnail.removeEventListener('click', () => goToIndex(index), false)
        }
    })
}
